
























































































import { Component, Vue, Prop } from 'vue-property-decorator';
import MaterialCategory from '@/classes/MaterialCategory';
import MaterialItem from '@/classes/MaterialItem';
import store from '@/store';

@Component
export default class MaterialItemForm extends Vue {
    @Prop() public id!: number;
    public categoryId: number | null = null;
    public listItem: string | null = null;
    public quantity: number | null = null;
    public outOfStock: boolean = false;

    private edit: boolean = false;
    private item: MaterialItem | null = null;

    public mounted() {
        if (this.id) {
            this.updateForm();
        }
    }

    public get categories(): MaterialCategory[] {
        const categories: MaterialCategory[] = this.$store.getters['material/getMaterialCategories'];
        if (categories !== undefined) {
            return categories;
        } else {
            return [];
        }
    }

    public submit() {
        const item = new MaterialItem();
        item.categoryId = Number(this.categoryId as number);
        item.listItem = this.listItem as string;
        item.quantityOfStock = Number(this.quantity as number);
        item.outOfStock = this.outOfStock;
        if (this.edit) {
            item.id = Number(this.id);
        }
        const dispatchString: string = this.edit ? 'material/editMaterialItem' : 'material/addMaterialItem';
        store.dispatch(dispatchString, item)
        .then((r: any) => {
            if (!r.success) {
                alert(r.message);
            } else {
                alert('Saved.');
                this.updateForm();
                this.$router.push('/administration/materialrequestmaintenance/item/' + r.item.id);
            }
        })
        .catch((e) => {
            alert(e);
        });
    }

    public deleteItem() {
        if (confirm('Delete item?')) {
            const item = new MaterialItem();
            item.id = Number(this.id);
            store.dispatch('material/deleteMaterialItem', item)
            .then((r: any) => {
                if (!r.success) {
                    alert(r.message);
                } else {
                    alert('Deleted.');
                    this.$router.push('/administration/materialrequestmaintenance/items');
                }
            })
            .catch((e) => {
                alert(e);
            });
        }
    }

    public updateForm() {
        if (this.id !== undefined && !isNaN(this.id)) {
            this.$store.dispatch('material/loadMaterialItems', true)
            .then(() => {
                const item: MaterialItem | undefined = this.$store.getters['material/getMaterialItemById'](this.id);
                if ( item !== undefined) {
                    this.item = item;
                    this.edit = true;
                    this.setUpValues(item);
                } else {
                    alert('Material Item not found.');
                    this.$router.push('/administration/materialrequestmaintenance/items');
                }
            });
        }
    }

    public setUpValues(item: MaterialItem): void {
        this.listItem = item.listItem as string;
        this.outOfStock = item.outOfStock as boolean;
        this.categoryId = item.categoryId as number;
        this.quantity = item.quantityOfStock as number;
    }

    public getUserProfileName(id: number) {
        const user = this.$store.getters.getUserProfileById(id);
        if (user) {
        return user.getFullName();
        } else {
        return '';
        }
  }
}
